export default __webpack_public_path__ + "static/4-d192a6490eedd5f0c5b4b8fe7dc5bf9e.png";